import React from "react";
import DatePicker from "react-date-picker";

function InputDatePicker({ objData, objFieldName, onChange, ...props }) {
  return (
    <DatePicker
      format="yyyy.MM.dd"
      value={objData[objFieldName] && new Date(objData[objFieldName])}
      onChange={(value) => onChange({ fieldName: objFieldName, value })}
      {...props}
    />
  );
}

export default InputDatePicker;
